import { Logger } from 'data/common';
import getMiddlewareSocketInstance from './SocketMiddleware';
import { getNewProduct } from '../actions';

const defaultMiddleName = 'general';
const sockets = {};

function getSocket(middleName) {
    Logger.debug('getSocket middle :', middleName);
    if (middleName && typeof sockets[middleName] !== 'undefined') return sockets[middleName];
    else return sockets[defaultMiddleName];
}

function connectToAllMiddlewares(dispatch, getState, access_token, middlesConfig) {
    Logger.debug('connectToAllMiddlewares');
    Object.keys(middlesConfig).map(middleName => {
        let middleConfig = middlesConfig[middleName];
        middleConfig['mid'] = middleName;
        Logger.debug('connectToAllMiddlewares / middle :', middleName);

        sockets[middleName] = getMiddlewareSocketInstance(dispatch, getState, access_token, middleConfig);

        sockets[middleName].on('newProduct', (homeId, productType, productIdentifier) => {
            const productKey = `${homeId}_${productType}_${productIdentifier}`;
            getNewProduct(homeId, productType, productIdentifier)
                .then(data => {
                    dispatch({
                        type: 'FHE__SET_NEW_PRODUCT_DETAILS',
                        product: data.productDetails
                    });
                    sockets[middleName].emit(`newProductFound${homeId}`, {
                        product: data.productDetails[productKey]
                    });
                })
                .catch(() => Logger.debug(`Le produit ${productKey} n'a pas été trouvé dans la BDD`));
        });
    });
}

function destroyMidConnection(middleName = null) {
    Logger.debug('destroyMidConnection', middleName);

    if (middleName && sockets[middleName]) sockets[middleName].destroy();
    else {
        Object.keys(sockets).map(middleName => {
            sockets[middleName].destroy();
            sockets[middleName] = null;
        });
    }
}

export { getSocket, connectToAllMiddlewares, destroyMidConnection };



// WEBPACK FOOTER //
// ./environments/fhe/common/AllSocketsMiddleware.js